import { makeObservable, observable, action } from "mobx";
import axios from "axios";

export class StoreAI {
  isLoaded = false;
  isWorking = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.isWorking = false;

    makeObservable(this, {
      isLoaded: observable,
      isWorking: observable,
      setIsLoaded: action,
      setIsWorking: action,
    });
  }

  setIsLoaded(loaded) {
    this.isLoaded = loaded;
  }

  setIsWorking(value) {
    this.isWorking = value;
  }

  extractJSON(str) {
    var firstOpen, firstClose, candidate;
    firstOpen = str.indexOf("{", firstOpen + 1);
    do {
      firstClose = str.lastIndexOf("}");
      // console.log("firstOpen: " + firstOpen, "firstClose: " + firstClose);
      if (firstClose <= firstOpen) {
        return null;
      }
      do {
        candidate = str.substring(firstOpen, firstClose + 1);
        // console.log("candidate: " + candidate);
        try {
          var res = JSON.parse(candidate);
          // console.log("...found");
          return res;
          // return [res, firstOpen, firstClose + 1];
        } catch (e) {
          // console.log("...failed");
        }
        firstClose = str.substr(0, firstClose).lastIndexOf("}");
      } while (firstClose > firstOpen);
      firstOpen = str.indexOf("{", firstOpen + 1);
    } while (firstOpen != -1);
  }

  async getWorkbookJsonFromStatement(statement, callback) {
    if (!statement) return;

    let model_description = statement;
    const url =
      "https://api-d7b62b.stack.tryrelevance.com/latest/studios/8ece0e7e-c8aa-4df2-aa19-7896c9b78c5b/trigger_limited";
    const params = {
      params: {
        model_description: model_description,
      },
      project: "a35a18fc94cf-4e83-93e8-d62d74de1a76",
    };

    let response;
    let resultAnswer;
    let jsonAnswer;
    try {
      const result = await axios.post(url, params);
      const resultData = result?.data;
      const cost = resultData?.cost;
      console.log("Cost:", cost);
      resultAnswer = resultData?.output?.answer;
      jsonAnswer = this.extractJSON(resultAnswer);
      resultAnswer = resultAnswer.replace("```json", "").replace("```", "");
      try {
        response = JSON.parse(resultAnswer);
      } catch (error) {
        response = jsonAnswer;
      }
    } catch (error) {
      console.log("ERROR getWorkbookJsonFromStatement", error, resultAnswer);
    }
    return response;
  }

  async getTableJsonFromStatement(statement, callback) {
    if (!statement) return;

    let list_description = statement;
    const url =
      "https://api-d7b62b.stack.tryrelevance.com/latest/studios/67a648b7-49e8-4614-b36e-58abe80eaefa/trigger_limited";
    const params = {
      params: {
        list_description: list_description,
      },
      project: "a35a18fc94cf-4e83-93e8-d62d74de1a76",
    };

    let response;
    let resultAnswer;
    try {
      const result = await axios.post(url, params);
      const resultData = result?.data;
      const cost = resultData?.cost;
      console.log("Cost:", cost);
      resultAnswer = resultData?.output?.answer;
      resultAnswer = resultAnswer.replace("```json", "").replace("```", "");
      response = JSON.parse(resultAnswer);
    } catch (error) {
      console.log("ERROR getTableJsonFromStatement", error, resultAnswer);
    }
    return response;
  }
}
